import {
  ENTER_PRACTICE_NAME,
  ENTER_PRACTICE_EMAIL,
  ENTER_PRACTICE_PHONE,
  SELECT_HOW_DID_YOU_HEAR_ABOUT_US,
  SELECT_PRACTICE_TYPE,
  SUBMIT_PRACTICE_INFO_COMPLETED,
  ENTER_FIELD_DATA,
  SELECT_PAYMENT_PLANS,
  ENTER_ROUTING_NUMBER,
  CONFIRM_ACCOUNT_NUMBER
} from '../actions';

import {
  GET_APPLICATION_COMPLETE
} from '../actions/onboarding';

import {
  BO_SIGNIFICANT_OWNER_FLAG
} from '../actions/ownership';

import {
  ENTER_STREET,
  ENTER_APTSUITE,
  ENTER_CITY,
  SELECT_STATE,
  ENTER_ZIP
} from '../../components/address/actions';

const defaultState = {
  name: null,
  capId: null,
  userId: null
};

const fieldList = {
  name: true,
  email: true,
  phone: true,
  type: true,
  businessType: true,
  howDidYouHearAboutUs: true,
  additionalInfo: true,
  contactFirstname: true,
  contactLastname: true,
  doctorFirstname: true,
  doctorLastname: true,
  doctorEmail: true,
  street: true,
  aptsuite: true,
  city: true,
  state: true,
  zip: true,
  legalName: true,
  businessTIN: true,
  maxPNITerm: true,
  boSignificantOwnerFlag: true,
  achAccountName: true,
  achRoutingNumber: true,
  achBankName: true,
  achAccountNumber: true,
  achConfirmAccountNumber: true,
  signeeFirstName: true,
  signeeLastName: true,
  signeeTitle: true
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case ENTER_PRACTICE_NAME:
      return { ...state, name: action.value };
    case ENTER_PRACTICE_EMAIL:
      return { ...state, email: action.value };
    case ENTER_PRACTICE_PHONE:
      return { ...state, phone: action.value };
    case SELECT_PRACTICE_TYPE:
      return { ...state, type: action.value };
    case SELECT_HOW_DID_YOU_HEAR_ABOUT_US:
      return { ...state, howDidYouHearAboutUs: action.value };
    case SUBMIT_PRACTICE_INFO_COMPLETED: {
      const { payload: { practice } } = action;
      return {
        ...state,
        ...practice
      };
    }
    case ENTER_STREET:
      return { ...state, street: action.value };
    case ENTER_APTSUITE:
      return { ...state, aptsuite: action.value };
    case ENTER_CITY:
      return { ...state, city: action.value };
    case SELECT_STATE:
      return { ...state, state: action.value };
    case ENTER_ZIP:
      return { ...state, zip: action.value };
    case ENTER_FIELD_DATA:
      const { fieldName, value } = action;
      return fieldList[fieldName] ? { ...state, [fieldName]: value } : state;
    case SELECT_PAYMENT_PLANS:
      return { ...state, maxPNITerm: action.value };
    case BO_SIGNIFICANT_OWNER_FLAG:
        return { ...state, boSignificantOwnerFlag: action.value };
    case ENTER_ROUTING_NUMBER:
      const { achInfo } = action;
      let newState = state;
      if (achInfo) {
        if (achInfo.routingNumber) {
          newState = { ...newState, achRoutingNumber: achInfo.routingNumber };
        } else {
          newState = { ...newState, achRoutingNumber: achInfo.null };
        }
        if (achInfo.bankName) {
          newState = { ...newState, achBankName: achInfo.bankName };
        } else {
          newState = { ...newState, achBankName: null };
        }
      }
      return newState;
    case CONFIRM_ACCOUNT_NUMBER:
      return { ...state, achConfirmAccountNumber: action.value };
    case GET_APPLICATION_COMPLETE:
      const { practice } = action.payload;
      return { ...practice };
    default:
      return state;
  }
};

